import httpService from './httpService';

/**
 * Submit a request to delete the current user's data (GDPR right to erasure).
 * Sends email to admin. Requires authenticated session.
 * @param {{ source?: 'portal'|'app' }} [body]
 * @returns {Promise<{ success: boolean; message: string }>}
 */
async function requestDataDeletion(body = {}) {
	return httpService.post('privacy/erasure-request', body);
}

/** Self-service GDPR copy (minimal). POST with empty body → own data only. */
async function exportMyData() {
	return httpService.post('privacy/export', {});
}

export default {
	requestDataDeletion,
	exportMyData,
};
